/**
 * Created by Giannis Kallergis on 2018-12-24
 */

import styled from "styled-components";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(320px, 1000px) 1fr;
  padding: 0 1rem;
`;

export default Wrapper;
